import React from "react"
import { NavLink } from "react-router-dom"
import styles from "../../styles/NavMain.module.css"

export default function MenuAnalyst() {
  return (
    <ul>
      <li>
        <NavLink to="/" end className={({ isActive }) => isActive ? styles.active : ""}>Workbench</NavLink>
      </li>
    </ul>
  )
}
